module.exports = __webpack_public_path__ + "static/index/img/baikal-801.c73efecc.jpg";